import styled from "@emotion/styled";

const SubmitButton = styled.button`
  display: block;
  height: 50px;
  width: 100%;
  font-size: 1rem;
  font-weight: 700;
  color: #fff;
  background-color: ${props => (props.disabled ? "#9fdcc2" : "#01bf71")};
  border: none;
  border-radius: 12px;
  cursor: ${props => (props.disabled ? "default" : "pointer")};
  opacity: ${props => (props.disabled ? 0.8 : 1)};
  box-shadow: ${props =>
    props.disabled ? "none" : "0 8px 20px rgba(1, 191, 113, 0.3)"};
  transition: background 0.15s ease, transform 0.15s ease;

  &:hover {
    background-color: ${props => (props.disabled ? "#9fdcc2" : "#04a763")};
    transform: ${props => (props.disabled ? "none" : "translateY(-1px)")};
  }
`;

export default SubmitButton;
